import React from "react";

const About = () => {
  return (
    <div
      className="container-fluid g-0 py-5 bg-secondary text-light"
      style={{ width: "100%" }}
    >
      <h4 className="text-center display-6 mb-4 IRANSansXG mt-5">درباره ما</h4>
      <div className="col-md-8 mx-auto pb-5">
        <p
          title="شرکت پردازش افزار رایان امین (پارا)"
          className="mx-5 mt-5 text-center text-large"
          style={{ textAlign: "justifyt", extJustify: "inter-word" }}
        >
          شرکت پردازش افزار رایانه امین (پارا) عضو پارک علم و فناوری دانشگاه
          تهران با هدف توسعه و تولید سامانه های نرم افزاری مانیتورینگ و پایش
          تاسیس شده است.
          <br />
          در حال حاضر سامانه های پایش هوای محیطی با هدف سنجش شاخص کیفیت ذرات و
          گاز های موجود در هوا و محاسبه شاخص کیفیت هوا و سامانه پایش خروجی دودکش
          های صنعتی با هدف محاسبه غلظت گازها و میزان ذرات خروجی از دودکش های
          کارخانجات و شرکت ها ، پروژه های تکمیل شده شرکت هستند.
        </p>
      </div>
    </div>
  );
};

export default About;
